import { connect } from 'react-redux';
import { DateRangePicker } from '../../../components/Filter/components/global/DateRangePicker';

const mapStateToProps = (state) => {
  return {
    dateFormat: state.filters.dateFormat,
    value: state.report.dates,
  };
};

const connected = connect(mapStateToProps)(DateRangePicker);
export { connected as DatePicker };
